import React from "react";
import Page from "../../organisms/Page";
import FormSection from "./FormSection";
import {BreadCrumbItem} from "../../organisms/HeaderSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/mascotas",
        label: "Mascotas",
    },
    {
        path: "/crear",
        label: "Crear",
        isActive: true
    }
]

function CrearMascota(){
    return (
        <Page title="Registro de Mascota" description="Creación de mascotas." breadCrumbs={breadCrumbs}>
            <FormSection />
        </Page>
    );
}

export default CrearMascota;